import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';

// Load config synchronously before bootstrapping
fetch('/assets/config.json')
  .then((response) => response.json())
  .then((config) => {
    if (config.sentryEnable) {
      Sentry.init({
        dsn: config.sentryDNS,
        environment: config.sentryENV,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        // Performance Monitoring
        tracesSampleRate: 0.1, //  Capture 10% of the transactions
        profilesSampleRate: 0.1,
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['http:localhost', /^http:\/\/yourserver\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
    }

    if (config.production) {
      enableProdMode();
    }

    return platformBrowser().bootstrapModule(AppModule);
  })
  .catch((err) => console.error(err));
